// ============================================================
// Datei: src/pages/Datenschutz.jsx
// PURPOSE:
// Kurze Datenschutzerklärung gemäss Schweizer revDSG
// für das Festival des Arcs Helferportal
// ============================================================

import React from "react";
import "../styles/impressum.css";
import "../styles/login.css";

const Datenschutz = () => {
	return (
		<div
			className="datenschutz-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_datenSchutz.png`}
		>
			<div className="impressum-container">
				<div className="impressum-card">

					<h1 className="impressum-title">Datenschutz</h1>

					<p>
						Diese Plattform dient der Organisation der freiwilligen Helferinnen
						und Helfer des <strong>Festival des Arcs</strong>. Dabei werden
						ausschliesslich jene personenbezogenen Daten verarbeitet, die für
						die Registrierung, Verwaltung der Helfer sowie die Planung von
						Einsätzen und Ressorts notwendig sind. Dazu gehören insbesondere
						Name, Geburtsdatum, E-Mail-Adresse, Rollen innerhalb des Festivals
						sowie gebuchte oder zugewiesene Schichten.
					</p>

					<p>
						Die Daten werden ausschliesslich für organisatorische Zwecke des
						Festivals verwendet und nicht an Dritte weitergegeben. Die
						Verarbeitung und Speicherung erfolgt auf Servern in der Schweiz
						(Infomaniak Cloud). Zur technischen Sicherheit werden unter anderem
						verschlüsselte Verbindungen (HTTPS), Passwort-Hashing sowie ein
						Rollen- und Berechtigungssystem eingesetzt.
					</p>

					<p>
						Personenbezogene Daten werden nur so lange gespeichert, wie dies für
						die Durchführung und Organisation des Festivals erforderlich ist.
						Betroffene Personen haben gemäss Schweizer Datenschutzgesetz
						(revDSG) das Recht auf Auskunft, Berichtigung oder Löschung ihrer
						Daten.
					</p>

					<p>
						Bei Fragen zum Datenschutz wenden Sie sich bitte an:
						<br />
						<a href="mailto:support@woodelicious.ch">
							support@festivaldesarcs.ch
						</a>
					</p>

				</div>
			</div>
		</div>
	);
};

export default Datenschutz;